import React, { useEffect, useState } from "react";
interface BreakPointProps {
  breakpoint: number;
}
const useCheckScreenSize = (props: BreakPointProps) => {
  const { breakpoint } = props;
  const [width, setWidth] = useState(window.innerWidth);
  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return width <= breakpoint;
};

export default useCheckScreenSize;
